import { OrderStatusEnum } from '../../lib/enums/index';
import lang from '../../lib/language';
import { getOrderStatusLabelByName } from '../../lib/util/TradingHelpers';

const statusOptionsData = [
  OrderStatusEnum.Filled,
  OrderStatusEnum.Cancelled,
  OrderStatusEnum.Rejected,
  OrderStatusEnum.OtherwiseExpired.split(' ')[1],
];

export const TRADE_HISTORY_TABLE_HEADERS = [
  lang.headerMyAccountMyStockSymbolName(),
  lang.commonTradingOrderType(),
  lang.headerMyAccountMyStockQuantity(),
  lang.headerTradeHistoryFillPrice(),
  lang.headerTradeHistoryAmount(),
  lang.commonDate(),
  lang.commonOrderStatusFilterTitle(),
];

export const statusOptionsLabels = statusOptionsData.map((value) => getOrderStatusLabelByName(value));
